import React, { useState, useRef, useEffect } from "react";
// Import CSS
import "./Card.scss";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchPayments } from "../../../../redux/slices/sliceActions";

// Circular Progress Bar component
// Circular Progress Bar component
const CircularProgressBar = ({ progress }) => {
  const radius = 68; // The outer radius of the circle
  const stroke = 10; // Stroke width
  const normalizedRadius = radius - stroke / 2; // Ensure the stroke is within the viewBox
  const circumference = normalizedRadius * 2 * Math.PI; // Total circumference
  const strokeDashoffset = circumference - (progress / 100) * circumference; // Progress calculation

  //switch case to check the progress and change the color of the progress bar
  const color = (progress) => {
    if (progress >= 0 && progress <= 9) {
      return "#FF1B1C";
    } else if (progress >= 10 && progress <= 29) {
      return "#FF7F11";
    } else if (progress >= 30 && progress <= 49) {
      return "#7CEA9C";
    } else if (progress >= 50 && progress <= 74) {
      return "#00AF54";
    } else if (progress >= 75) {
      return "#0B2C3B";
    }
  };

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      viewBox={`0 0 ${radius * 2} ${radius * 2}`}
    >
      <circle
        stroke="lightgray"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke={color(progress)}
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + " " + circumference}
        style={{
          strokeDashoffset,
          transform: "rotate(-90deg)",
          transformOrigin: "50% 50%",
        }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="20"
        fill="black"
      >
        {`${progress}%`}
      </text>
    </svg>
  );
};

const Card = ({ setCurrentSelected }) => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [dataInCards, setDataInCards] = useState({});

  useEffect(() => {
    if (profile.totalHouses) {
      setDataInCards({
        paymentsMade: profile.paidInvoices?.total || 0,
        pendingInvoices: profile.unpaidInvoices?.total || 0,
        numberOfPaymentsMade: profile.totalPaidInvoices || 0,
        numberOfPendingInvoices: profile.totalUnpaidInvoices || 0,
        housesOccupied: Number(profile.occupiedHouses) || 0,
        totalHouses: Number(profile.totalHouses) || 0,
        arrearsReconciled: profile.totalArrearsPaid || 0,
        totalInvoiceAmount: profile.unpaidInvoices[0]?.amount || 0,
        totalPaymentsAmount: profile.paidInvoices[0]?.amount || 0,
      });
    }
    console.log("profile in phone", dataInCards);
  }, [profile]);

  // Sample card data
  const cardData = [
    {
      title: "Payments made",
      progress: ((dataInCards?.paymentsMade / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100).toFixed(1) || 0,
      descriptionTitle: "Payment details",
      details: `${dataInCards?.numberOfPendingInvoices} Invoices Pending\n${dataInCards?.numberOfPaymentsMade} Invoices Paid\n${dataInCards?.numberOfPendingInvoices} Arrears`,
    },
    {
      title: "Houses Occupied",
      progress: ((dataInCards?.housesOccupied / dataInCards?.totalHouses) * 100).toFixed(1),
      descriptionTitle: "Occupation Details",
      details: `${dataInCards?.housesOccupied} Houses Occupied\n${dataInCards?.totalHouses} Total Houses\n${(dataInCards?.totalHouses - dataInCards?.housesOccupied)} Vacant Houses`,
    },
    {
      title: "Pending Invoices",
      progress:  ((dataInCards?.pendingInvoices / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100).toFixed(1) || 0,
      descriptionTitle: "Invoices Details",
      details:  `${dataInCards?.numberOfPendingInvoices} Invoices Pending\n${dataInCards?.numberOfPaymentsMade} Invoices Paid\n${dataInCards?.numberOfPendingInvoices} Arrears`,
    },
    {
      title: "Arrears Reconciled",
      progress: ((dataInCards?.arrearsReconciled / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100).toFixed(1) || 0,
      descriptionTitle: "Arrears Details",
      details:  `${dataInCards?.numberOfPendingInvoices} Invoices Pending\n${dataInCards?.numberOfPaymentsMade} Invoices Paid\n${dataInCards?.numberOfPendingInvoices} Arrears`,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(1); // Start with the second card (index 1)
  useEffect(() => {
    setCurrentSelected(currentIndex);
  }, [currentIndex]);
  const sliderRef = useRef(null);
  const cardWidth = 250; // Width of each card in pixels
  const gapWidth = 0; // Gap between cards in pixels

  const moveToCard = (index) => {
    setCurrentIndex(index);
    const totalScrollLeft = index * (cardWidth + gapWidth);
    sliderRef.current.scrollLeft = totalScrollLeft;
  };

  useEffect(() => {
    // Center the initial card
    moveToCard(currentIndex);
  }, []);

  return (
    <div className="report-card-component">
      <div className="slider-container" ref={sliderRef}>
        <div className="slider">
          {cardData.map((card, index) => (
            <button
              key={index}
              className="card-button"
              onClick={() => moveToCard(index)}
            >
              <div className="card">
                <div className="card-title">{card.title}</div>
                <div className="mid-section">
                  <div className="progress-container">
                    <CircularProgressBar progress={card.progress} />
                  </div>
                  <div className="description-of-progress">
                    {/* write code for four divs of class rectangle with different colors */}
                    <div className="rectangle-and-text">
                      <div
                        className="rectangle"
                        style={{ backgroundColor: "#FF1B1C" }}
                      ></div>
                      <div className="text">0-9%</div>
                    </div>
                    <div className="rectangle-and-text">
                      <div
                        className="rectangle"
                        style={{ backgroundColor: "#FF7F11" }}
                      ></div>
                      <div className="text">10-29%</div>
                    </div>
                    <div className="rectangle-and-text">
                      <div
                        className="rectangle"
                        style={{ backgroundColor: "#7CEA9C" }}
                      ></div>
                      <div className="text">30-49%</div>
                    </div>
                    <div className="rectangle-and-text">
                      <div
                        className="rectangle"
                        style={{ backgroundColor: "#00AF54" }}
                      ></div>
                      <div className="text">50-74%</div>
                    </div>
                    <div className="rectangle-and-text">
                      <div
                        className="rectangle"
                        style={{ backgroundColor: "#0B2C3B" }}
                      ></div>
                      <div className="text">75%+</div>
                    </div>
                  </div>
                </div>
                <div className="house-details">
                  <div className="description-title">
                    {card.descriptionTitle}
                  </div>
                  <div className="description-text">
                    {card.details.split("\n").map((line, idx) => (
                      <div key={idx}>{line}</div>
                    ))}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card;
